import { createAsyncThunk } from '@reduxjs/toolkit';
import { closeSmsChannel } from 'services/smsConversations';
import { ICloseSmsChannelPayload } from 'services/smsConversations/types';

interface IProps {
  channelId: number;
  payload: ICloseSmsChannelPayload;
}

export const ThunkCloseSmsChannel = createAsyncThunk<number, IProps, { rejectValue: Error }>(
  'smsConversations/closeSmsChannel',
  async ({ channelId, payload }, { rejectWithValue }) => {
    try {
      await closeSmsChannel(channelId, payload);
      return channelId;
    } catch (error) {
      const { data } = error as { data: Error };
      return rejectWithValue(data);
    }
  },
);
